var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformanceImprovement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Performance Improvement"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3299 18.0502C20.3299 18.7702 20.2399 19.4602 20.0599 20.1302H3.94992C3.75992 19.4602 3.66992 18.7702 3.66992 18.0502C3.66992 13.4602 7.40992 9.72021 11.9999 9.72021C16.5899 9.72021 20.3299 13.4602 20.3299 18.0502Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.9401 18.0499H13.8101C13.8101 15.9099 12.0701 14.1799 9.94008 14.1799C7.93008 14.1799 6.28008 15.6999 6.08008 17.6499C6.28008 14.5599 8.85008 12.1099 11.9901 12.1099C15.1301 12.1099 17.9301 14.7699 17.9301 18.0499H17.9401Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0098 18.0498L16.9998 13.0698",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.59996 12.6001V9.8301H2.45996L4.32996 6.6001L6.18996 9.8301H5.05996V10.8601",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.3996 12.6001V9.8301H21.5396L19.6696 6.6001L17.8096 9.8301H18.9396V10.8601",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.2796 8.13012V7.09012H10.1396L11.9996 3.87012L13.8696 7.09012H12.7396V8.13012",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceImprovement);
export default __webpack_public_path__ + "static/media/Performance Improvement.42017fd9c83279bdce9d61bb86f232ab.svg";
export { ForwardRef as ReactComponent };